import { booleanObj, showMessage, showMoreMinThreshold } from "./types";
import groupBy from "lodash/groupBy";

const sortSizes = (sizes: SizeType) =>
  sizes.sort((a: Size, b: Size) => {
    return parseInt(a.size) > parseInt(b.size)
      ? 1
      : parseInt(b.size) > parseInt(a.size)
        ? -1
        : 0;
  });

const sortSizesForBabyAndToddler = (
  sizes: SizeType,
  isBabyAndToddler: boolean,
) => {
  const sizesSorted = sortSizes(sizes);

  if (isBabyAndToddler) {
    const sizesPremAndOther = sizesSorted.filter(
      (sortedSize) =>
        !sortedSize.size.toLowerCase().includes("tiny baby") &&
        !sortedSize.size.toLowerCase().includes("newborn") &&
        !sortedSize.size.includes("month") &&
        !sortedSize.size.includes("year"),
    );

    const sizeTinyBaby = sizesSorted.filter((sortedSize) =>
      sortedSize.size.toLowerCase().includes("tiny baby"),
    );

    const sizeNewborn = sizesSorted.filter((sortedSize) =>
      sortedSize.size.toLowerCase().includes("newborn"),
    );

    const sizesInMonths = sortSizes(
      sizes.filter((size) => size.size.includes("month")),
    );

    const sizesInYears = sortSizes(
      sizes.filter((size) => size.size.includes("year")),
    );

    return [
      ...sizesPremAndOther,
      ...sizeTinyBaby,
      ...sizeNewborn,
      ...sizesInMonths,
      ...sizesInYears,
    ];
  }
  return sizesSorted;
};

type Size = {
  size: string;
  isSelected: boolean;
  sizeHeadline: string;
  isAvailable: boolean;
  showReduced: boolean;
  label: string;
};

type SizeType = Size[];

type SizeGroupValueProps = {
  sizes: SizeType;
  showMore?: number;
  isBabyAndToddlerCategory: boolean;
};

export function getSizeGroupValues({
  sizes,
  showMore,
  isBabyAndToddlerCategory,
}: SizeGroupValueProps) {
  const sortedSizes = sortSizesForBabyAndToddler(
    sizes,
    isBabyAndToddlerCategory,
  );
  const groupedSizes = groupBy(sortedSizes, "sizeHeadline");

  const showMoreMinThreshold: showMoreMinThreshold = Object.keys(
    groupedSizes,
  ).reduce(
    (prev, curr) => ({
      ...prev,
      // @ts-ignore
      [curr]: showMore === undefined ? groupedSizes[curr].length : showMore,
    }),
    {},
  );

  const canShowMore: booleanObj = Object.keys(groupedSizes).reduce(
    (prev, curr) => ({
      ...prev,
      // @ts-ignore
      [curr]: groupedSizes[curr].length > showMoreMinThreshold[curr],
    }),
    {},
  );

  const showLessmessage: showMessage = Object.keys(groupedSizes).reduce(
    (prev, curr) => ({
      ...prev,
      [curr]: "less",
    }),
    {},
  );

  const showMoremessage: showMessage = Object.keys(groupedSizes).reduce(
    (prev, curr) => ({
      ...prev,
      // @ts-ignore
      [curr]: `${groupedSizes[curr].length - showMoreMinThreshold[curr]} more`,
    }),
    {},
  );

  return {
    groupedSizes,
    showMoreMinThreshold,
    showMoremessage,
    showLessmessage,
    canShowMore,
  };
}

export const babyAndToddlerCategories = [
  {
    name: "Baby & Toddlerwear (0-3 yrs)",
    url: "/baby-child/baby-toddlerwear-0-3-yrs/c6000030",
  },
];
